import { render, staticRenderFns } from "./tieba-float-panel-item-view.vue?vue&type=template&id=7871e384&scoped=true&"
import script from "./tieba-float-panel-item-view.vue?vue&type=script&lang=js&"
export * from "./tieba-float-panel-item-view.vue?vue&type=script&lang=js&"
import style0 from "./tieba-float-panel-item-view.vue?vue&type=style&index=0&id=7871e384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7871e384",
  null
  
)

export default component.exports